import './Input.css';
import { forwardRef } from 'react';

const TextArea = forwardRef(({ className = 'input full-width resize-area', ...rest }, ref) => {
    return (
        <textarea {...rest} ref={ref} className={rest.className ? rest.className : className} />
    )
});

export default TextArea;